import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import enGbLocale from "@fullcalendar/core/locales/en-gb";
import axios from "axios";
import { decryptData } from "../Services/TabServices";

const HomePageDoctorCalender = () => {
    const storedUserId = sessionStorage.getItem("userId");
const CrmID = storedUserId ? decryptData(storedUserId) : null;
  const token = sessionStorage.getItem("token");

  const [selectedDoctor, setSelectedDoctor] = useState("All Doctors");
  const [doctorEvents, setDoctorEvents] = useState<Record<string, any[]>>({});
  const [doctorColors, setDoctorColors] = useState<Record<string, string>>({});
  const [events, setEvents] = useState<any[]>([]);

  const getRandomColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 50%)`;
  };

  useEffect(() => {
  const fetchDoctorsFromApi = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user/ScheduledAppointmentsByCrmId/${CrmID}`,{
          
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
      );

      const response = res.data;
      

      setDoctorColors((prevColors) => {
        const newDoctorColors: Record<string, string> = {};
        const newDoctorEvents: Record<string, any[]> = {};

        response.forEach((doc: any) => {
          const color = prevColors[doc.doctorName] || getRandomColor();
          newDoctorColors[doc.doctorName] = color;

          newDoctorEvents[doc.doctorName] = doc.events.map((event: any) => ({
            ...event,
            color,
            textColor: "#fff",
          }));
        });
        setDoctorEvents(newDoctorEvents);
        return newDoctorColors;
      });
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  fetchDoctorsFromApi();
}, []);

  useEffect(() => {
    if (selectedDoctor === "All Doctors") {
      setEvents(Object.values(doctorEvents).flat());
    } else {
      setEvents(doctorEvents[selectedDoctor] || []);
    }
  }, [doctorEvents, selectedDoctor]);
  const handleDoctorClick = (doctor: string) => {
    setSelectedDoctor(doctor);
  };
  return (
    <div className="grid grid-cols-12 gap-2  mt-16 w-full">
      {/* Sidebar */}
      <div className="hidden lg:inline col-span-2 p-4 shadow-lg rounded-xl bg-white">
        <h2 className="text-lg font-semibold mb-3">Doctors</h2>
        <ul className="space-y-2 text-sm">
          <li
            className={`flex items-center gap-2 cursor-pointer hover:text-blue-500 transition ${
              selectedDoctor === "All Doctors" ? "font-bold text-blue-600" : ""
            }`}
            onClick={() => handleDoctorClick("All Doctors")}
          >
            <span className="h-3 w-3 bg-gray-500 rounded-full"></span>
            All Doctors
          </li>
          {Object.keys(doctorEvents).map((doctor)=>(
            <li
              key={doctor}
              className={`flex items-center gap-2 cursor-pointer hover:text-blue-500 transition ${
                doctor === selectedDoctor ? "font-bold text-blue-600" : ""
              }`}
              onClick={() => handleDoctorClick(doctor)}
            >
              <span
                className="h-3 w-3 rounded-full"
                style={{ backgroundColor: doctorColors[doctor] }}
              ></span>
              {doctor}
            </li>
          ))}
        </ul>
      </div>

      {/* Calendar */}
      <div className="col-span-12 lg:col-span-10 px-5 shadow-lg rounded-xl bg-white">
        <div className="flex justify-between ">
 <h3 className="text-sm md:text-lg font-semibold mt-1">
          {selectedDoctor}'s Calendar
        </h3>
         <div className="lg:hidden flex items-center w-[50%]  border rounded-md shadow-sm shadow-gray-400 mb-1 mt-1">
  <select
    className="flex-1 py-1 px-4 text-xs text-[#009A85] border-none focus:outline-none focus:ring-0 appearance-none bg-transparent"
    value={selectedDoctor}
    onChange={(e) => handleDoctorClick(e.target.value)}
  >
    <option className="text-black" value="All Doctors">All Doctors</option>
    {Object.keys(doctorEvents).map((doctor) => (
      <option key={doctor} className="text-black" value={doctor}>
        {doctor}
      </option>
    ))}
  </select>
  <span className="pr-2 text-[#009A85]">▾</span>
</div>
        </div>
       
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="timeGridWeek"
          initialDate={new Date()}
          nowIndicator={true}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          locale={enGbLocale}
          buttonText={{
            today: "📅 Today",
            month: "Month",
            week: "Week",
            day: "Day",
          }}
          slotLabelFormat={{
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
              meridiem: "short",

          }}
          eventTimeFormat={{
            hour: "numeric",
            minute: "2-digit",
            meridiem: "short",
            hour12: true,
          }}
       
          events={events}
          slotMinTime="09:00:00"
          slotMaxTime="21:00:00"
          slotDuration="00:15:00"
          height="78vh"
          eventContent={(eventInfo) => {
            const { event, view } = eventInfo;
            const start = new Date(event.start!);

            const formatTime = (date: Date) =>
              date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              });

            const isMonthView = view.type === "dayGridMonth";

            return (
              <div className="flex items-center gap-1 leading-tight">
                {isMonthView ? (
                  <>
                    <span
                      className="inline-block w-2 h-2 rounded-full"
                      style={{
                        backgroundColor:
                          event.backgroundColor || event.borderColor,
                      }}
                    ></span>
                    <span className="text-[11px] font-semibold">
                      {formatTime(start)}
                    </span>
                    <span className="text-[11px]">{event.title}</span>
                  </>
                ) : (
                  <div className="flex flex-col leading-tight">
                    <span className="text-[11px] font-semibold">
                      {formatTime(start)}
                    </span>
                    <span className="text-[11px]">{event.title}</span>
                  </div>
                )}
              </div>
            );
          }}
          eventClick={(info) => {
            const calendarApi = info.view.calendar;
            const eventStart = info.event.start;
            if (eventStart) {
              calendarApi.changeView("timeGridDay", eventStart); 
            }
          }}
        />

        {/* Inline style overrides for UI */}
        <style>{`
.fc .fc-toolbar.fc-header-toolbar {
  font-size: 12px !important; 
}

.fc .fc-toolbar button {
  font-size: 12px !important;
  padding: 0px 6px !important;
  height: 25px !important;
}

.fc .fc-toolbar-title {
  font-size: 12px !important;
  font-weight: 600 !important;
}

.fc-button:hover {
  background: #e5e7eb;
}
  
.fc-event {
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 4px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  border: none;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.fc-event:hover,
.fc-timegrid-event-harness:hover,
.fc-daygrid-event-harness:hover {
  cursor: pointer;
  z-index: 9999 !important; 
  white-space: normal;      
  overflow: visible;         
  max-width: none;          
  min-width: 100%;    
  transform: scale(1.02);    
}

.fc-dayGridMonth-view .fc-scroller {
  padding-right: 12px !important; 
  box-sizing: content-box;
}

.fc-timeGridWeek-view .fc-scroller,
.fc-timeGridDay-view .fc-scroller {
  scrollbar-width: none;      
  -ms-overflow-style: none;   
}

.fc-dayGridMonth-view .fc-scroller::-webkit-scrollbar,
.fc-timeGridWeek-view .fc-scroller::-webkit-scrollbar,
.fc-timeGridDay-view .fc-scroller::-webkit-scrollbar {
  display: none;
}
        `}</style>
      </div>
    </div>
  );
};

export default HomePageDoctorCalender;
